async function authFetch(url, options = {}) {
  const token = sessionStorage.getItem('token');
  const originalHeaders = options.headers || {};
  const mergedHeaders = { ...originalHeaders };
  if (token && !mergedHeaders.Authorization) {
    mergedHeaders.Authorization = token;
  }
  
  const response = await fetch(url, { ...options, headers: mergedHeaders });

  if (response.status === 401) {
    try {
      const configRes = await fetch('/config.json');
      const config = await configRes.json();
      if (config.CRM_URL) {
        window.location.href = config.CRM_URL;
      }
    } catch (e) {
      console.error('Ошибка загрузки config.json:', e);
    }
  }
  
  return response;
}

// Получить корневые навыки (или level groups)
export async function fetchRootSkills(apiBase) {
  const res = await authFetch(`${apiBase}/api/v1/skills/children`);
  if (!res.ok) throw new Error('Ошибка загрузки скиллов');
  const data = await res.json();
  return data.payload;
}

// Получить детей для конкретного узла
export async function fetchChildrenSkills(apiBase, nodeId) {
  const url = nodeId == null
    ? `${apiBase}/api/v1/skills/children`
    : `${apiBase}/api/v1/skills/children?parentId=${nodeId}`;
  const res = await authFetch(url);
  if (!res.ok) throw new Error('Ошибка загрузки дочерних скиллов');
  const data = await res.json();
  return data.payload;
}

// Обновить навык
export async function updateSkill(apiBase, skill) {
  const res = await authFetch(`${apiBase}/api/v1/skills`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify(skill),
  });
  if (!res.ok) throw new Error('Ошибка обновления навыка');
  return await res.json();
}

// Получить всё дерево навыков
export async function fetchSkillTree(apiBase) {
  const res = await authFetch(`${apiBase}/api/v1/skills/tree`);
  if (!res.ok) throw new Error('Ошибка загрузки дерева навыков');
  const data = await res.json();
  return data.payload;
}

// Получить навык по id
export async function fetchSkillById(apiBase, id) {
  const res = await authFetch(`${apiBase}/api/v1/skills/${id}`);
  if (!res.ok) throw new Error('Ошибка загрузки навыка');
  const data = await res.json();
  return data.payload;
}

// Получить список грейдов
export async function fetchGrades(apiBase, { search = '', page = 1, take = 100 } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('searchQuery', search);
  params.set('page', String(page));
  params.set('objectsCount', String(take));
  const url = `${apiBase}/api/v1/grades/get-by-filter?${params.toString()}`;
  const res = await authFetch(url);
  if (!res.ok) throw new Error('Ошибка загрузки грейдов');
  const data = await res.json();
  // ожидаем payload = { objects: [], total: number }
  const view = data.payload || { objects: [], total: 0 };
  return Array.isArray(view.objects) ? view.objects : [];
}

// Создать грейд
export async function createGrade(apiBase, grade) {
  const res = await authFetch(`${apiBase}/api/v1/grades`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify(grade),
  });
  if (!res.ok) throw new Error('Ошибка создания грейда');
  return await res.json();
}

// Обновить грейд
export async function updateGrade(apiBase, grade) {
  const res = await authFetch(`${apiBase}/api/v1/grades`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify(grade),
  });
  if (!res.ok) throw new Error('Ошибка обновления грейда');
  return await res.json();
}

// Удалить грейд
export async function deleteGrade(apiBase, id) {
  const res = await authFetch(`${apiBase}/api/v1/grades/${id}`, {
    method: 'DELETE',
    headers: { 'accept': 'application/json' },
  });
  if (!res.ok) throw new Error('Ошибка удаления грейда');
  return true;
}

// Создать новый навык
export async function createSkill(apiBase, skill) {
  const res = await authFetch(`${apiBase}/api/v1/skills`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify(skill),
  });
  if (!res.ok) throw new Error('Ошибка создания навыка');
  return await res.json();
}

// Поиск навыков
export async function searchSkills(apiBase, query) {
  const res = await authFetch(`${apiBase}/api/v1/skills/search?query=${encodeURIComponent(query)}`);
  if (!res.ok) throw new Error('Ошибка поиска навыков');
  const data = await res.json();
  return data.payload;
}

// Удалить навык
export async function deleteSkill(apiBase, id) {
  const res = await authFetch(`${apiBase}/api/v1/skills/${id}`, {
    method: 'DELETE',
    headers: { 'accept': 'application/json' },
  });
  if (!res.ok) throw new Error('Ошибка удаления навыка');
  return true;
}

export async function fetchSkillGradeTable(apiBase) {
  const res = await authFetch(`${apiBase}/api/v1/skillToGrades/GetSkillGradeTable`);
  if (!res.ok) throw new Error('Ошибка загрузки таблицы связей навыков и грейдов');
  const data = await res.json();
  return data.payload;
}

// Получить все навыки через get-by-filter без фильтров
export async function fetchAllSkills(apiBase, { take = 1000 } = {}) {
  const url = `${apiBase}/api/v1/skills/get-by-filter?objectsCount=${encodeURIComponent(String(take))}`;
  const res = await authFetch(url);
  if (!res.ok) throw new Error('Ошибка загрузки навыков');
  const data = await res.json();
  const view = data.payload || { objects: [], total: 0 };
  return Array.isArray(view.objects) ? view.objects : [];
}

export async function fetchUserSkills(apiBase, parentSkillId) {
  const res = await authFetch(`${apiBase}/api/v1/skillToUsers/my-skills?parentSkillId=${parentSkillId ?? ''}`);
  if (!res.ok) throw new Error('Ошибка загрузки таблицы связей навыков и грейдов');
  const data = await res.json();
  return data.payload;
}

export async function createSkillToGradeBinding(apiBase, skillId, gradeId, skillLevel) {
  const res = await authFetch(`${apiBase}/api/v1/skillToGrades/CreateBinding`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify({ skillId, gradeId, skillLevel }),
  });
  if (!res.ok) throw new Error('Ошибка создания связи навыка и грейда');
  return await res.json();
}

export async function deleteSkillToGradeBinding(apiBase, skillId, gradeId) {
  const res = await authFetch(`${apiBase}/api/v1/skillToGrades/DeleteBinding`, {
    method: 'POST', // The image shows POST for DeleteBinding, assuming it's correct.
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify({ skillId, gradeId }),
  });
  if (!res.ok) throw new Error('Ошибка удаления связи навыка и грейда');
  return await res.json();
}

// Обновить существующую связь навыка и грейда (по id)
export async function updateSkillToGrade(apiBase, { id, skillId, gradeId, skillLevel }) {
  const res = await authFetch(`${apiBase}/api/v1/skillToGrades`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify({ id, skillId, gradeId, skillLevel }),
  });
  if (!res.ok) throw new Error('Ошибка обновления уровня навыка для грейда');
  return await res.json();
}

// Обновить статус изучения для SkillToUser
export async function updateLearningStatus(apiBase, skillToUserId, status) {
  const res = await authFetch(`${apiBase}/api/v1/skillToUsers/update-status/${skillToUserId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify(status),
  });
  if (!res.ok) throw new Error('Ошибка обновления статуса изучения');
  return await res.json();
}

// Получить SkillToUser по id
export async function fetchSkillToUser(apiBase, id) {
  const res = await authFetch(`${apiBase}/api/v1/skillToUsers/${id}`);
  if (!res.ok) throw new Error('Ошибка загрузки SkillToUser');
  const data = await res.json();
  return data.payload;
}

// Обновить SkillToUser
export async function updateSkillToUser(apiBase, model) {
  const res = await authFetch(`${apiBase}/api/v1/skillToUsers`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify(model),
  });
  if (!res.ok) throw new Error('Ошибка обновления SkillToUser');
  return await res.json();
}

// Запланировать изучение навыка
export async function planSkillLearning(apiBase, skillId, externalTaskId) {
  const res = await authFetch(`${apiBase}/api/v1/skillToUsers/plan-learning`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    body: JSON.stringify({ skillId, externalTaskId }),
  });
  if (!res.ok) throw new Error('Ошибка планирования изучения навыка');
  return await res.json();
}